export enum AccountPlanId {
    Free = '5892A864-B4B7-4FF8-9B9B-E27409A0223E',
    Pro = '97CC50B7-F4C0-405F-B434-66FD5CAFB750',
    Enterprise = '38DD453D-27CC-4D63-B34E-D69B85349D20',
    Custom = '00D8BAD0-687D-4C4A-BE23-7F1EA2010FFE'
}